import { useQuery } from "@tanstack/react-query";
import { dealerApi } from "../services/dealer.api";
import { TDealerFilter } from "../../../interfaces/dealerInterface";
import { IApiPagination } from "../../../interfaces/IPagination";

export type UseDealersQueryParams = {
  filter: TDealerFilter;
  pagination: IApiPagination;
};

export const useDealersQuery = (params: UseDealersQueryParams) => {
  return useQuery({
    queryKey: ["dealers", params],
    queryFn: async () => {
      const res = await dealerApi.getDealers(params.filter, params.pagination);
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const useDealerByIdQuery = (dealerId?: string) => {
  return useQuery({
    queryKey: ["dealer-by-id", dealerId],
    queryFn: () => dealerApi.getDealerById(dealerId as string),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!dealerId,
  });
};
